module.exports = __webpack_public_path__ + "static/media/314.98f54ff1.svg";